import { render, staticRenderFns } from "./OrderViewCancellationPolicies.vue?vue&type=template&id=5386e1de&scoped=true&"
import script from "./OrderViewCancellationPolicies.vue?vue&type=script&lang=js&"
export * from "./OrderViewCancellationPolicies.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewCancellationPolicies.vue?vue&type=style&index=0&id=5386e1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386e1de",
  null
  
)

export default component.exports